import React, { useEffect, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import {
  getImageUrl,
  getImageVariant,
} from '../../../../utility/util/util.service';
import { AvInput, AvForm } from 'availity-reactstrap-validation';
import ImageDropzoneComponent from '../../form/dropzones/image-dropzone/image-dropzone.component';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';
import { connect } from 'react-redux';
import {
  closeModalSafely,
  getTranslationsCollapsable,
  handleSubmit,
} from './create-or-edit-info-menu-entry.service';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { fetchMenuEntries } from '../../../../redux/store/store.actions';
import {
  setIsCreateInfoModalOpen,
  setIsEditInfoModalOpen,
} from '../../../../redux/modal/modal.actions';
import TextEditorField from '../../form/fields/TextEditorField';
import LocalizedTitleField from '../../form/fields/LocalizedTitleField';

const CreateOrEditInfoModal = ({
  isCreateInfoModalOpen,
  isEditInfoModalOpen,
  createInfoModalData,
  editInfoModalData,
  menu,
  intl,
  store,

  fetchMenuEntries,
  setIsCreateInfoModalOpen,
  setIsEditInfoModalOpen,
}) => {
  const [targetInfoData, setTargetInfoData] = useState({});
  const [uploadImage, setUploadImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isTranslationsOpen, setIsTranslationsOpen] = useState(false);
  const formRef = useRef(null);

  const isOpen = isCreateInfoModalOpen || isEditInfoModalOpen;
  const isEditMode = isEditInfoModalOpen;
  const isCreateMode = isCreateInfoModalOpen;
  const menuEntry = (isEditMode ? editInfoModalData : {}) || {};
  const closeModal = () =>
    isCreateInfoModalOpen
      ? setIsCreateInfoModalOpen(false)
      : setIsEditInfoModalOpen(false);
  const userLocale = intl?.locale.substring(0,2);
  const modalTitleId = isEditMode ? 'editInfoTitle' : 'createInfoTitle';

  useEffect(() => {
    if (isOpen) {
      // reset modal on opening
      setTargetInfoData(
        (menuEntry && {
          ...menuEntry,
        }) ||
          {},
      );
      setUploadImage(null);
      const variant = getImageVariant('menuEntry');
      setPreviewUrl(getImageUrl(menuEntry?.image, variant) || null);
    } else {
      // reset modal on closing
      setUploadImage(null);
      setPreviewUrl(null);
      setTargetInfoData({});
    }
  }, [isOpen, store]);

  const _closeModalSafely = () => closeModalSafely(isSubmitting, closeModal);
  const _handleSubmit = (event, errors, values) => {
    handleSubmit(
      event,
      errors,
      values,
      uploadImage,
      targetInfoData,
      isEditMode,
      setIsSubmitting,
      setTargetInfoData,
      closeModal,
      () => fetchMenuEntries(menu?.id, true),
    );
  };
  const _getTranslationsCollapsable = () =>
    getTranslationsCollapsable(
      targetInfoData,
      isTranslationsOpen,
      setIsTranslationsOpen,
      true,
      false,
      userLocale,
      true,
      true,
      setTargetInfoData,
      true,
    );

  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={_closeModalSafely}
      title={intl.formatMessage({ id: modalTitleId })}
      footer={
        <div className="align-content-center">
          <SaveSubmitButton
            data-testid="saveButtonInfoMenu"
            className="m-auto"
            isSubmitting={isSubmitting}
            onClick={() => formRef?.current.handleSubmit()}
          />
        </div>
      }
    >
      <div className="px-1">
        <AvForm ref={formRef} onSubmit={_handleSubmit} disabled={isSubmitting}>
          <div className="mt-1">
            {isEditMode && <AvInput name="id" value={menuEntry?.id} hidden />}
            {isCreateMode && (
              <AvInput
                name="categoryId"
                value={createInfoModalData?.targetCategoryId || null}
                hidden
              />
            )}
            <LocalizedTitleField
              data-testid="titleInfoMenu"
              object={targetInfoData}
              locale={userLocale}
              required
            />
            <TextEditorField
              data-testid="descriptionInfoMenu"
              setter={setTargetInfoData}
              object={targetInfoData}
              locale={userLocale}
              isDisabled={isSubmitting}
            />
            <ImageDropzoneComponent
              data-testid="imageUploadInfoMenu"
              propertyName="image"
              object={targetInfoData}
              setter={setTargetInfoData}
              previewUrl={previewUrl}
              setPreviewUrl={setPreviewUrl}
              setUploadImage={setUploadImage}
              isDisabled={isSubmitting}
            />
            {_getTranslationsCollapsable()}
          </div>
        </AvForm>
      </div>
    </ModalSheet>
  );
};

const mapStateToProps = (state) => ({
  isCreateInfoModalOpen: state.modals.isCreateInfoModalOpen,
  isEditInfoModalOpen: state.modals.isEditInfoModalOpen,
  createInfoModalData: state.modals.createInfoModalData,
  editInfoModalData: state.modals.editInfoModalData,
  menu: state.store.menu,
  store: state.store.store,
});

export default connect(mapStateToProps, {
  fetchMenuEntries,
  setIsCreateInfoModalOpen,
  setIsEditInfoModalOpen,
})(injectIntl(CreateOrEditInfoModal));
